export default "* Muslingeskal\n* Lys";